import React from 'react'
import { Box, Button, FormControl, FormControlLabel, FormLabel, Input, Paper, Radio, RadioGroup, TextField, TextareaAutosize, Typography } from '@mui/material'

const PartySettings = () => {

    return (
        <Box
            sx={{
                // paddingTop: "90px",
                // paddingLeft: { xs: "8px", sm: "70px", lg: "80px" },
                // paddingRight: { xs: "8px", lg: "30px" },
                // paddingBottom: "8px",
                boxSizing: "content-box",
            }}
        >
            <Box

                sx={{
                    minHeight: "550px",
                    borderRadius: "10px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px"
                }}
            >
                <Paper
                    sx={{
                        // backgroundColor: "background.paper",
                        padding: { xs: "8px", sm: "20px" },
                        borderRadius: "8px",
                        boxShadow:
                            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
                        ":hover": {
                            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
                        },
                        transition: "all 1s ease-in-out",
                    }}
                >
                    <Typography sx={{
                        fontWeight: 700,
                        fontSize: '24px'
                    }} >
                        Party Settings
                    </Typography>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: { sm: "flex-start" },
                            flexWrap: { xs: "wrap", md: "nowrap" },
                            flexDirection: { xs: "column", sm: "row" },
                            marginBottom: "0px",
                        }}
                    >
                        <Box sx={{ display: "flex", flexDirection: "column" }}>

                            <FormControl sx={{ marginLeft: "20px", marginTop: "10px" }}>
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    defaultValue="Enable Party Category / Grouping"
                                    name="radio-buttons-group"
                                >
                                    <FormControlLabel value="Enable Party Category / Grouping" control={<Radio />} label="Enable Party Category / Grouping" />
                                    <FormControlLabel value="Enable Separate Shipping Address for Customers" control={<Radio />} label="Services" />
                                </RadioGroup>
                            </FormControl>
                        </Box>
                    </Box>

                </Paper>


            </Box>
        </Box >

    )
}

export default PartySettings